import store from '@/store/'
import { LineList, LineListNew, LineListTree } from '@/api/common'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      lineListMixin: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 没有枚举请求
      if (!vm.lineListMixin.length) {
        LineList().then(res => {
          if (res.code === '000000') {
            vm.lineListMixin = res.data
            store.dispatch('set_line_list', res.data)
          }
        })
      }
    })
  },
  computed: {
    ...mapGetters(['lineListEnum']),
  }
}
